import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DialogueService {

  private apiUrl = `${environment.backendUrl}/api/dialogues`;

  constructor(private http: HttpClient) {}

  getDialogue():Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }
}
